import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import tick from "../../../assets/successTick.gif";
import { Check,X } from "lucide-react";
const ConfirmDialog = ({ open, title, message, onConfirm, onCancel }) => (

  <Dialog className="max-w-md mx-auto" open={open} onClose={onCancel} fullWidth PaperProps={{
    sx: {
      borderRadius: "12px", // 👈 custom border radius here
    },
  }}>
    <DialogTitle
      textAlign="start"
      color="#572575"
      mb={2}
      fontFamily="Inter"
      fontSize="28px"
    >
      <span className="flex items-center flex-col font-siromi">
      <img src={tick} alt="" width={100} height={100} className="h-16 w-16 bg-[#F4ECF8] rounded-full p-2" />
      {title}
      </span>
    </DialogTitle>
    <DialogContent className="text-center text-base font-medium font-altisunisa -mt-8">{message}</DialogContent>
    <DialogActions className="justify-center gap-4 mb-4 font-altisunisa">
      <Button onClick={onCancel} className="bg-[#57257514] text-[#572575] font-bold flex items-center gap-2 px-6 hover:bg-[#57257514]" >
         <X /> Not Yet</Button>
      <Button onClick={onConfirm} variant="contained" className="flex items-center gap-2 bg-[#572575] font-bold px-6 hover:bg-[#572575]">
      <Check />  Yes, Confirmed
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
